export function sortArrayByStartTime<T extends { startTimeMs: number }>(items: T[]): T[] {
    return items.sort((a, b) => a.startTimeMs - b.startTimeMs);
}
